module.exports = __webpack_public_path__ + "static/media/IMG_1378.8de882fb.jpg";